
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.366 8.668h3.652c.12 2.18.82 4.204 1.95 5.92a6.67 6.67 0 01-5.602-5.92zm0-1.333a6.67 6.67 0 015.602-5.92 11.933 11.933 0 00-1.95 5.92H1.366zm13.268 0h-3.652c-.12-2.18-.82-4.204-1.95-5.92a6.67 6.67 0 015.602 5.92zm0 1.333a6.67 6.67 0 01-5.602 5.92 11.933 11.933 0 001.95-5.92h3.652zm-8.28 0h3.292A10.605 10.605 0 018 13.729a10.605 10.605 0 01-1.646-5.061zm0-1.333A10.606 10.606 0 018 2.274a10.606 10.606 0 011.646 5.06H6.354z","fill":"#910000"}})])
          )
        }
      }
    